var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"broken-chart-container"},[_c('div',{staticClass:"title-content"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),(_vm.score)?_c('p'):_vm._e()]),_c('div',{ref:"lineChart",staticClass:"line-chart-content"})])
}
var staticRenderFns = []

export { render, staticRenderFns }